import axiosBasicInstance from '../axiosConfig';

const getListDepartment = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/list-department`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addDepartment = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/add-department`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

const updateDepartment = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/update-department`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

const deleteDepartment = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/delete-department`, data);

      return response;
   } catch (error) {
      throw error;
   }
};


export { getListDepartment, addDepartment, updateDepartment, deleteDepartment };
